import {
	SET_ACCOUNT_FRANCHISE_LIST,
	SET_FRANCHISE_MODELS,
	SET_SELECTED_FRANCHISE,
	SET_ACCOUNT_DATA,
	SET_ACCOUNT_THEME_KIT,
	SET_INCLUDE_DESTINATION_CHARGE_IN_PRICE
} from '../actions/types';

export default function accountData(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_ACCOUNT_DATA:
				return action.payload;
			case SET_ACCOUNT_FRANCHISE_LIST:
				return {
					...state,
					accountFranchises: action.payload
				};
			case SET_ACCOUNT_THEME_KIT:
				return {
					...state,
					accountTheme: action.payload
				};
			case SET_SELECTED_FRANCHISE:
				return {
					...state,
					selectedFranchise: action.payload
				};
			case SET_FRANCHISE_MODELS:
				return {
					...state,
					franchiseModels: action.payload
				};
			case SET_INCLUDE_DESTINATION_CHARGE_IN_PRICE:
				return {
					...state,
					includeDestinationChargeInPrice: action.payload
				};
			// no default
		}
	}

	return state;
}
